import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const getStaffList = createAsyncThunk('attendance-list', async (params: any, thunkAPI) => {
  try {
    const {data} = await axios.get(`${api}attendance/staff/list`, {
      params, // 👈
    })
    return data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
  }
})

export const getLecturerList = createAsyncThunk(
  'attendance-list',
  async (params: any, thunkAPI) => {
    try {
      const {data} = await axios.get(`${api}attendance/lecturers/list`, {
        params, //
      })
      return data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)

export const createStaffAttendance = createAsyncThunk(
  'attendance-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}attendance/staff/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const createStaffPartialLeave = createAsyncThunk(
  'store-staff-partial-leave',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}attendance/staff/partial/leave`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const staffLeavesList = createAsyncThunk(
  'staff-leave-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}staff-leave/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createStaffLeave = createAsyncThunk(
  'create-staff-leave',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}staff-leave/staff/leave`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const editStaffLeave = createAsyncThunk('staff-leave-edit', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`${api}staff-leave/edit/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const approveStaffLeave = createAsyncThunk(
  'staff-leave-approve',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}staff-leave/approve/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const deleteStaffLeave = createAsyncThunk(
  'staff-leave-delete',
  async (id: string, thunkAPI) => {
    try {
      const response = await axios.post(`${api}staff-leave/delete/${id}`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStaffAttendance = createAsyncThunk(
  'staff-attendance',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}attendance/staff/attendance`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStaffAttendanceReport = createAsyncThunk(
  'attendance-report',
  async (data: {year: number; month: number; staff_type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}attendance/report`, {
        params: data,
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getStaffAttendancePayroll = createAsyncThunk(
  'attendance-payroll',
  async (data: {staff_id: string[]; year: number; month: number; staff_type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}attendance/payroll`, {
        params: data,
      })
      return response.data
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeStaffAttendancePayroll = createAsyncThunk(
  'attendance-payroll-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}attendance/payroll/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const exportPayrollExcel = createAsyncThunk(
  'attendance-payroll-excel',
  async (params: {year: number; month: number; staff_type: string}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}attendance/payroll/excel/report`, {
        params,
        responseType: 'blob',
      })
      return response.data
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.response?.data?.errors || 'Something went wrong')
    }
  }
)



type AttendanceState = {
  errors: any
}

const initialState: AttendanceState = {
  errors: '',
}

export const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createStaffAttendance.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
    builder.addCase(storeStaffAttendancePayroll.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = attendanceSlice.actions
export default attendanceSlice.reducer
